import Vue from 'vue'
import Vuex from 'vuex'
import { KEY } from '../constants/key'
import { PAYLOAD } from '../constants/payload'
import axios from 'axios'

Vue.use(Vuex)

var jwt = require('jsonwebtoken')

// Store for handling all of the api called methods
export default new Vuex.Store({
  state: {
    token: jwt.sign(JSON.stringify(PAYLOAD), KEY, { algorithm: 'HS256' }),
    dealers: [],
    actionsCompleted: false,
    token_url: 'https://odoo.kencove.com/api/authentication/oauth2/token',
    // dealer_url: 'https://cors-anywhere.herokuapp.com/https://api-kencove.p.kencove.com/lookup/dealer/powerfields',
    dealer_url: 'https://api-kencove.p.kencove.com/lookup/dealer/powerfields',
    token: 'fake'
  },
  mutations: {
    // Mutation that goes and gets all of the dealers
    getAllDealers (state, userLocation) {
      const querystring = require('querystring')

      // Make sure the access token was retrived
      if (state.token !== '' && state.token !== 'error') {
        axios.defaults.headers.common['Authorization'] = `X-Auth-Token ${state.token}`

        axios.get(state.dealer_url, {
          params: {
            'lat': userLocation.lat,
            'long': userLocation.lng
          }
        })
          .then(response => {
            state.dealers = response.data
            state.actionsCompleted = true
          })
          .catch(error => {
            state.dealers = []
            state.actionsCompleted = true
            console.log(error)
          })
      }
    }
  },
  actions: {
    // Action for updating the token
    updateToken ({ commit }) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          commit('getNewToken')
          resolve()
        }, 1000)
      })
    },
    // Action for updating all the dealers
    updateDealers ({ commit }, userLocation, category) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          commit('getAllDealers', userLocation)
          resolve()
        }, 1000)
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js